<template>
    <div class="relative group w-fit select-none z-2" ref="mainMenu" :class="{open: menuOpen}">
        <div class="p-2.5 cursor-pointer h-full group-[.open]:bg-stone-100 flex items-center " @click="menuOpen = !menuOpen">
            <i class="pi pi-bars text-3xl text-stone-100 group-[.open]:text-stone-900"></i>
        </div>
        <div v-if="menuOpen" class="absolute bg-stone-100 w-80">
            <div class="menuItem relative text-stone-900 hover:bg-stone-900 hover:text-stone-100 text-2xl cursor-pointer" v-for="item in model" :key="item.key"
            @click="(event) => {
                item.command?.({ originalEvent: event, item }); 
                if(!item.items){
                    menuOpen=false;
                }
                else{
                    (event.currentTarget as HTMLElement).classList.toggle('open')
                    };
                }">
                <div class="py-2.5 mx-[60px] flex justify-between">
                    <a :href="item.url">{{ item.label }}</a>
                    <div v-if="item.items">></div>
                </div>
                <div v-if="item.items" class="submenuItem opacity-90 md:opacity-100 hidden top-0 left-0 md:left-full relative bg-stone-100 w-80 md:absolute">
                    <div class="text-stone-900 py-2.5 text-2xl cursor-pointer bg-stone-100  hover:text-stone-100 hover:bg-stone-900" v-for="subItem in item.items" :key="subItem.key"
                    @click="(event) => {subItem.command?.({ originalEvent: event, item: subItem }); menuOpen=false;}">
                        <a class="py-2.5 mx-[60px]" :href="subItem.url">{{ subItem.label }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onClickOutside } from '@vueuse/core';
import type { MenuItem, MenuItemCommandEvent } from 'primevue/menuitem';
import { ref, onMounted } from 'vue';

const props = defineProps<{
  model:MenuItem[]
}>()
const target = useTemplateRef<HTMLElement>('mainMenu')
const menuOpen = ref(false);

onClickOutside(target, () => {
    menuOpen.value = false;
});

</script>

<style lang="scss" scoped>

.menuItem {
    @include tablet(){
        &:hover {
            .submenuItem {
                display: block;
                color:var(--color-stone-100) !important;
                background-color: var(--color-stone-900) !important;
            }
        }
    }
    &:hover {
        .submenuItem {
            color:var(--color-stone-100) !important;
            background-color: var(--color-stone-900) !important;
        }
    }
    &.open {
        .submenuItem {
            display: block;
            color:var(--color-stone-100) !important;
            background-color: var(--color-stone-900) !important;
        }
    }
}
</style>